/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Document_Credit_Note_BrandInputs */

const en_inbound_document_credit_note_brand = /** @type {(inputs: Inbound_Document_Credit_Note_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit note of the brand`)
};

/**
* | output |
* | --- |
* | "Credit note of the brand" |
*
* @param {Inbound_Document_Credit_Note_BrandInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_document_credit_note_brand = /** @type {((inputs?: Inbound_Document_Credit_Note_BrandInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Document_Credit_Note_BrandInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_document_credit_note_brand(inputs)
});